import { render, staticRenderFns } from "./LogisticExtrasView.vue?vue&type=template&id=c6a4ab44"
import script from "./LogisticExtrasView.vue?vue&type=script&lang=js"
export * from "./LogisticExtrasView.vue?vue&type=script&lang=js"
import style0 from "./LogisticExtrasView.vue?vue&type=style&index=0&id=c6a4ab44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports